<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>
<div class="seccion-media" *ngIf="!showSpinner">
  <p>
    Ups, algo salio mal...
  </p>
</div>